import qs from "qs";

export const geocodeKey = "AIzaSyDOikYPJlWzZwbEIZqdqAk9P2cQqw4DGEw";

const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json";

export async function geocodeCoords(lat, lng) {
  let response = await (await fetch(
    `${baseUrl}?${qs.stringify({ latlng: `${lat},${lng}`, key: geocodeKey })}`
  )).json();
  return response;
}



// WEBPACK FOOTER //
// ./src/backend/geocode.js